module.exports = __webpack_public_path__ + "static/media/flag-icon-uk.6f382b2d.png";